import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import * as config from '@config';
import { addMessage, MsgLevel } from '@features/messages/messagesSlice';
import { GetToken } from '@utils/storage';
import { GetHotelOrdersQueryReq, SaveHotelOrdersQueryReq } from '../../utils/storage';

const initialState = {
    data: [],
    total: 0,
    fetching: false,
    fetched: false,
    error: '',
};

export const defaultQueryReq = {
    page: 1,
    pageSize: 3,
};

export const fetchHotelOrders = createAsyncThunk('hotel_orders/fetch', async (query, thunkAPI) => {
    if (!query) {
        query = GetHotelOrdersQueryReq();
    }
    const queryParams = {
        limit: query.pageSize,
        offset: (query.page - 1) * query.pageSize,
    };
    const queryString = new URLSearchParams(queryParams).toString();
    console.log('fetchHotelOrders', queryString);
    try {
        const resp = await axios.get(`${config.apiURL}/sabre/hotel/orders?${queryString}`, {
            headers: {
                Authorization: `Bearer ${GetToken()}`,
            },
        });
        SaveHotelOrdersQueryReq(query);
        return resp.data;
    } catch (error) {
        const msg = error.response?.data?.error || 'Something went wrong with fetchHotelOrders';
        thunkAPI.dispatch(
            addMessage({
                type: MsgLevel.Error,
                content: msg,
            })
        );
        return thunkAPI.rejectWithValue(msg);
    }
});

const hotelOrdersSlice = createSlice({
    name: 'hotel_orders',
    initialState,
    reducers: {
        cleanupHotelOrders: (state) => {
            console.log('cleanup hotel orders');
            state = initialState;
            return state;
        },
    },
    extraReducers: (builder) => {
        // Add reducers for additional action types here, and handle loading state as needed
        builder
            .addCase(fetchHotelOrders.pending, (state, action) => {
                state.fetching = true;
            })
            .addCase(fetchHotelOrders.fulfilled, (state, action) => {
                const orders = action.payload.orders;
                const total = action.payload.total;
                state.fetched = true;
                state.fetching = false;
                state.data = orders;
                if (total) {
                    state.total = total;
                }
            })
            .addCase(fetchHotelOrders.rejected, (state, action) => {
                state = { ...initialState };
                state.error = action.payload;
                console.log(action);
            });
    },
});

export const { cleanupHotelOrders } = hotelOrdersSlice.actions;

export default hotelOrdersSlice.reducer;
